import React from 'react';
import { Card } from './ui/Card';
import { XCircle, AlertTriangle, BatteryWarning } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-12 md:py-16 bg-[#0a0e1a] relative" data-id="element-159">
      <div className="container mx-auto px-4" data-id="element-160">
        {/* Opening Hook */}
        <div className="max-w-3xl mx-auto text-center mb-10" data-id="element-161">
          <div className="inline-flex items-center justify-center p-3 bg-red-500/10 rounded-full mb-6" data-id="element-162">
            <AlertTriangle className="h-8 w-8 text-red-500" data-id="element-163" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-164">
            Es la misma historia todas las noches.
          </h2>
          <p className="text-lg text-gray-300 mb-6 leading-relaxed" data-id="element-165">
            Tu hijo lleva tres horas pegado a la pantalla, absorto en un mundo
            que no entiendes. Sientes esa punzada de culpa y te preguntas:{' '}
            <span className="italic text-white" data-id="element-166">
              "¿De qué le va a servir esto en el futuro?"
            </span>
            .
          </p>
          <p className="text-lg text-gray-300 leading-relaxed" data-id="element-167">
            La realidad es que tu hijo tiene una pasión por sistemas complejos
            que la mayoría de los adultos envidiaría. Solo le falta un puente
            que conecte su juego favorito con la creación de software real.
          </p>
        </div>

        {/* The Problem */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-12" data-id="element-168">
          <div className="order-2 md:order-1" data-id="element-169">
            <div className="bg-gradient-to-br from-red-900/20 to-transparent p-1 rounded-2xl border border-red-900/30" data-id="element-170">
              <div className="bg-[#0f1623] rounded-xl p-8" data-id="element-171">
                <h3 className="text-2xl font-bold text-white mb-4 flex items-center gap-3" data-id="element-172">
                  <XCircle className="text-red-500 h-6 w-6" data-id="element-173" />
                  El verdadero problema
                </h3>
                <p className="text-gray-300 mb-4" data-id="element-174">
                  El problema no son los videojuegos, es el{' '}
                  <span className="text-red-400 font-semibold" data-id="element-175">
                    consumo pasivo
                  </span>
                  . Prohibir las pantallas solo genera peleas y aleja a tu hijo
                  de la tecnología que dominará el mañana.
                </p>
                <p className="text-gray-300" data-id="element-176">
                  Inscribirlo en cursos de programación aburridos que parecen
                  una clase de matemáticas extra solo hace que odie el código
                  antes de empezar. Estás atrapado entre el miedo a que "se
                  queme el cerebro" y la frustración de no saber cómo guiarlo.
                </p>
              </div>
            </div>
          </div>
          <div className="order-1 md:order-2 text-center md:text-left" data-id="element-177">
            <h3 className="text-3xl font-bold text-white mb-4" data-id="element-178">
              ¿Por qué lo que has intentado no funciona?
            </h3>
            <p className="text-gray-400" data-id="element-179">
              Los métodos tradicionales ignoran la psicología del niño gamer.
            </p>
          </div>
        </div>

        {/* Why it failed grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-180">
          {[{
          title: 'Reglas de Tiempo',
          desc: "Las reglas de 'tiempo limitado' no enseñan disciplina, solo generan ansiedad por jugar más rápido.",
          icon: <BatteryWarning className="h-6 w-6 text-orange-500" data-id="element-181" />
        }, {
          title: 'Apps Genéricas',
          desc: 'Las apps de aprendizaje genéricas no tienen el nivel de dopamina y diversión de sus juegos reales.',
          icon: <XCircle className="h-6 w-6 text-red-500" data-id="element-182" />
        }, {
          title: 'Tutoriales Difíciles',
          desc: 'Los tutoriales técnicos en YouTube suelen estar en inglés o son demasiado complejos para un niño.',
          icon: <AlertTriangle className="h-6 w-6 text-yellow-500" data-id="element-183" />
        }, {
          title: 'Lenguajes Aburridos',
          desc: "Intentar que aprenda lenguajes 'serios' como Java desde el día uno es la forma más rápida de que se rinda.",
          icon: <XCircle className="h-6 w-6 text-red-500" data-id="element-184" />
        }].map((item, idx) => <Card key={idx} className="h-full border-gray-800 bg-[#111827]/50" data-id="element-185">
              <div className="mb-4 bg-gray-800/50 w-12 h-12 rounded-lg flex items-center justify-center" data-id="element-186">
                {item.icon}
              </div>
              <h4 className="text-lg font-bold text-white mb-2" data-id="element-187">
                {item.title}
              </h4>
              <p className="text-sm text-gray-400" data-id="element-188">{item.desc}</p>
            </Card>)}
        </div>
      </div>
    </section>;
}